import { toAddressTypeDto } from '../../address/addresses.interface';
import { withErrorParsing } from '../../dialect-cloud-api/data-service-errors';
export class DataServiceDappMessages {
    constructor(api) {
        this.api = api;
    }
    async send(command) {
        var _a;
        if (((_a = command.addressTypes) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            return;
        }
        if ('recipient' in command) {
            return this.unicast(command);
        }
        if ('recipients' in command) {
            return this.multicast(command);
        }
        return this.broadcast(command);
    }
    async unicast(command) {
        var _a;
        return withErrorParsing(this.api.unicast({
            ...command,
            notificationTypeId: command.notificationTypeId,
            recipientPublicKey: command.recipient.toString(),
            addressTypes: (_a = command === null || command === void 0 ? void 0 : command.addressTypes) === null || _a === void 0 ? void 0 : _a.map((addr) => toAddressTypeDto(addr)),
        }));
    }
    async multicast(command) {
        var _a;
        if (command.recipients.length === 0) {
            return;
        }
        return withErrorParsing(this.api.multicast({
            ...command,
            notificationTypeId: command.notificationTypeId,
            recipientPublicKeys: command.recipients.map((it) => it.toString()),
            addressTypes: (_a = command === null || command === void 0 ? void 0 : command.addressTypes) === null || _a === void 0 ? void 0 : _a.map((addr) => toAddressTypeDto(addr)),
        }));
    }
    async broadcast(command) {
        var _a;
        return withErrorParsing(this.api.broadcast({
            ...command,
            notificationTypeId: command.notificationTypeId,
            addressTypes: (_a = command === null || command === void 0 ? void 0 : command.addressTypes) === null || _a === void 0 ? void 0 : _a.map((addr) => toAddressTypeDto(addr)),
        }));
    }
}
//# sourceMappingURL=data-service-dapp-messages.js.map